// Companies and schools Chloé has worked with or studied at, with their logos.

const ORGANIZATIONS = {
	companies: [
		{
			id: "radio-france",
			name: "Radio France",
			src: "/logo/company/radio-france-logo.png",
			alt: "Radio France",
			link: "https://www.radiofrance.fr",
			category: "company",
			role: "AI ML Engineer (2024-Present)",
		},
		{
			id: "ircam-amplify",
			name: "IRCAM Amplify",
			src: "/logo/company/ircamamplify-logo.png",
			alt: "IRCAM Amplify",
			link: "https://www.ircamamplify.io",
			category: "company",
			role: "Tech Lead & ML Engineer (2022-2024)",
		},
		{
			id: "sony-csl",
			name: "Sony CSL Paris",
			src: "/logo/company/sony-csl-logo.png",
			alt: "Sony CSL Paris",
			link: "https://csl.sony.fr",
			category: "company",
			role: "Research Intern (2020)",
		},
		{
			id: "orange",
			name: "Orange",
			src: "/logo/company/orange-logo.png",
			alt: "Orange",
			link: "https://www.orange.com",
			category: "company",
			role: "QoS Validation (2017)",
		},
	],

	institutions: [
		{
			id: "ircam",
			name: "IRCAM",
			src: "/logo/company/ircam-logo.png",
			alt: "IRCAM",
			link: "https://www.ircam.fr",
			category: "education",
			role: "Master Science et Musique (2019-2020)",
		},
		{
			id: "sorbonne",
			name: "Sorbonne Université",
			src: "/logo/company/sorbonne-logo.png",
			alt: "Sorbonne Université",
			link: "https://www.sorbonne-universite.fr",
			category: "education",
			role: "Master Science et Musique (2019-2020)",
		},
		{
			id: "imt-atlantique",
			name: "IMT Atlantique",
			src: "/logo/company/imt-logo.png",
			alt: "IMT Atlantique",
			link: "https://www.imt-atlantique.fr",
			category: "education",
			role: "Diplôme Ingénieur (2016-2021)",
		},
		{
			id: "polito",
			name: "Politecnico di Torino",
			src: "/logo/company/polito-logo.png",
			alt: "Politecnico di Torino",
			link: "https://www.polito.it",
			category: "education",
			role: "Exchange Program",
		},
	],
};

// Optical correction applied to each mark's height in the strip: seals with
// fine detail must be larger than a solid square to read at the same weight.
const LOGO_SCALE = {
	"radio-france": 1,
	"ircam-amplify": 1,
	"sony-csl": 1.1,
	orange: 0.8,
	ircam: 1,
	sorbonne: 1.3,
	"imt-atlantique": 1.2,
	polito: 1.3,
};

/** The logo strip on the home page, in display order, each with its optical `scale`. */
export const getFeaturedOrganizations = () => {
	return [
		ORGANIZATIONS.companies.find((c) => c.id === "radio-france"),
		ORGANIZATIONS.companies.find((c) => c.id === "ircam-amplify"),
		ORGANIZATIONS.companies.find((c) => c.id === "sony-csl"),
		ORGANIZATIONS.companies.find((c) => c.id === "orange"),
		ORGANIZATIONS.institutions.find((i) => i.id === "ircam"),
		ORGANIZATIONS.institutions.find((i) => i.id === "sorbonne"),
		ORGANIZATIONS.institutions.find((i) => i.id === "imt-atlantique"),
		ORGANIZATIONS.institutions.find((i) => i.id === "polito"),
	]
		.filter(Boolean)
		.map((o) => ({ ...o, scale: LOGO_SCALE[o.id] || 1 }));
};
